import { useEffect, useMemo, useRef } from 'react'

import _debounce from 'lodash-es/debounce'

export function useDebounce(
  cb: () => void,
  delay: number,
  options?: { leading?: boolean; trailing?: boolean },
) {
  const cbRef = useRef(cb)

  useEffect(() => {
    cbRef.current = cb
  })

  return useMemo(() => {
    return _debounce(cbRef.current, delay, options)
  }, [delay, options])
}
